import { Component, OnInit } from '@angular/core';
import {
  AlertItem, AlertType, Appraisal, AppraisalMeasurements, ComponentModal, Contract, Equipment,
  EquipmentModel, Lane, MessageModal, Spot,
  User
}
  from 'src/app/core/models';
import {
  AlertService,
  AppraisalService, ContractGlobalService, ContractService, EquipmentModelService,
  EquipmentService, LaneService, ModalService,
  SpotService, AppraisalMeasurementsService,
  StorageService,
  StorageKey
} from 'src/app/core/services';
import { AppraisalCreateOrUpdateComponent } from '../appraisal-create-or-update/appraisal-create-or-update.component';
import { ClosedModalError } from 'src/app/core/errors';
import { Gb } from 'src/app/core/services/growthbook.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import moment from 'moment';
import {
  AppaisalMeasurementsUpdateComponent
} from '../appaisal-measurements-update/appaisal-measurements-update.component';
import { ExportModalComponent } from '../export-modal/export-modal.component';
import { VerifyPermissionUrl } from '../../utils/verify-permission-url';

interface AppraisalSpotCards {
  spotId: number;
  appraisals: Appraisal[];
  isOpen: boolean;
};

interface AppraisalContractCards {
  contractId: string;
  contractCode: string;
  contractName: string;
  spotCards: AppraisalSpotCards[];
  spotCardsPaginated: AppraisalSpotCards[];
  appraisalLength: number;
  isOpen: boolean;
};

@Component({
  selector: 'app-appraisal-list',
  templateUrl: './appraisal-list.component.html',
  styleUrls: ['./appraisal-list.component.sass']
})

export class AppraisalListComponent implements OnInit {

  public loading = false;
  public contractId = null;
  public contract = new Contract();
  public contractGlobal = [];
  public appraisals = [];
  public appraisalContractCards: AppraisalContractCards[] = [];
  public appraisalContractCardsCopy: AppraisalContractCards[] = [];
  public modalState;
  public contracts: Contract[] = [];
  public contractsById: { [id: number]: Contract } = {};
  public gb: Gb;
  public searchForm: FormGroup;
  public params: any = {};
  public lanesById: { [param: number]: Lane } = {};
  public lanes: Lane[] = [];
  public spotsById: { [param: number]: Spot } = {};
  public spots: Spot[] = [];
  public equipmentsById: { [param: number]: Equipment } = {};
  public equipments: Equipment[] = [];
  public equipmentModelsById: { [param: number]: EquipmentModel } = {};
  public searchValue: string;
  public loadingTimer = 0;
  public appraisalMeasurements: Array<AppraisalMeasurements>;
  public currentPermissions = [];
  public viewMode: 'contrato' | 'ensaio' = 'contrato';
  public appraisalsFlatList: Appraisal[] = [];
  public appraisalsFlatListPaginated: Appraisal[] = [];
  public sortExperimentCodeOrder: 'asc' | 'desc' = 'desc';
  public canEdit = false;

  constructor(
    private contractGlobalService: ContractGlobalService,
    private contractService: ContractService,
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private appraisalService: AppraisalService,
    private laneService: LaneService,
    private equipmentService: EquipmentService,
    private equipmentModelService: EquipmentModelService,
    private spotService: SpotService,
    private alertService: AlertService,
    private storageService: StorageService,
    private appraisalMeasurementsService: AppraisalMeasurementsService,
    private verifyPermissionUrl: VerifyPermissionUrl
  ) {
    this.gb = new Gb();
  }

  async ngOnInit() {
    this.verifyPermissionUrl.execute(['ViewAppraisal']);
    this.loading = true;
    this.setContractGlobal();
    this.createSearchForm();
    await this.gb.init();
    this.setCanEdit();
    await this.getcontract();
    this.contracts.map(contract => this.contractsById[contract.id] = contract);
    await this.getAppraisals();
  }

  setCanEdit() {
    const currentUser: User = this.storageService.get(StorageKey.currentUser);
    if (currentUser?.superUser) {
      this.canEdit = true;
      return;
    }
    const adminPermissions: string[] = this.storageService.get(StorageKey.adminPermissions) || [];
    this.canEdit = adminPermissions.includes('UpdateAppraisal');
  }

  async getcontract() {
    const currentUser: User = this.storageService.get(StorageKey.currentUser);
    if (!currentUser?.superUser && !currentUser?.adminUser && !currentUser?.adminManagerUser) {
      this.currentPermissions = this.storageService.get(StorageKey.currentPermissions);
      const contractIds = this.currentPermissions &&
        this.currentPermissions.filter(contractPermission =>
          contractPermission?.actionIds?.indexOf('ViewAppraisal') >= 0).map(m => m.contractId);

      await this.contractService.list({}).then(res => {
        this.contracts = res.result.filter(c => contractIds.includes(c.id));
      });
    } else {
      await this.contractService.list({}).then(res => {
        this.contracts = res.result;
      });
    }
  }

  async getAppraisals(search = false) {
    this.appraisalsFlatList = [];
    this.appraisalContractCards = [];
    this.appraisalContractCardsCopy = [];
    if (this.contractGlobal !== null && this.contractGlobal.length > 0) {
      this.contractGlobal.map(contractId => {
        this.setAppraisalContractCards(this.contracts.find(c => c.id === contractId), search);
      });
    } else {
      if (this.contracts.length > 0) {
        this.contracts.map(async contract => {
          await this.setAppraisalContractCards(contract, search);
        });
      } else {
        this.loading = false;
      }
    }
  }

  async setAppraisalContractCards(contract, search = false) {
    this.loading = true;
    const params = { ...this.params };
    delete params['contractId[in]'];
    try {
      const res = await this.appraisalService.list({ contractId: contract?.id, ...params });
      if (res.result.length > 0) {
        const spotIds = [...new Set(res.result.map(a => a.spotId))];
        const laneIds = [...new Set(res.result.map(ap => ap.laneId))];
        const equipmentIds = [...new Set(res.result.map(ap => ap.equipment.id))];
        const data: any = {
          contractId: contract.id,
          contractCode: contract.code,
          contractName: contract.name,
          spotCards: spotIds.map(spotId => ({
            spotId,
            appraisals: res.result.filter(ap => ap.spotId === spotId),
            isOpen: false
          })),
          spotCardsPaginated: [],
          appraisalLength: res.result.length,
          isOpen: false
        };
        await Promise.all([
          this.getLanes(laneIds),
          this.getSpots(spotIds),
          this.getEquipments(equipmentIds)
        ]);
        if (!this.appraisalContractCards.some(a => a.contractId === data.contractId)) {
          this.appraisalContractCards.push(data);
          this.appraisalContractCardsCopy.push(data);
          this.buildFlatList();
          if (search) {
            this.appraisalContractCards = this.searchByExperimentCode(this.searchValue);
            this.appraisalsFlatList = this.appraisalsFlatList.filter(
              appraisal => appraisal.experimentCode.includes(this.searchValue)
            );
          }
        }
      }
    } catch (error) {
      console.error('Erro ao carregar contratos:', error);
    } finally {
      this.loadingTimer++;
      this.handleLoading();
    }
  }

  async getLanes(ids: number[]) {
    await this.laneService.list({ 'id[in]': `[${ids}]` }).then(res => {
      res.result.map(lane => {
        this.lanesById[lane.id] = lane;
        if (this.lanes.filter(a => a.id === lane.id).length === 0) {
          this.lanes.push(lane);
        }
      });
    });
  }

  async getSpots(ids: number[]) {
    await this.spotService.list({ 'id[in]': `[${ids}]` }).then(res => {
      res.result.map(spot => {
        this.spotsById[spot.id] = spot;
        if (this.spots.filter(a => a.id === spot.id).length === 0) {
          this.spots.push(spot);
        }
      });
    });
  }

  async getEquipments(ids: number[]) {
    await this.equipmentService.list({ 'id[in]': `[${ids}]` }).then(async res => {
      res.result.map(eq => {
        this.equipmentsById[eq.id] = eq;
        if (this.equipments.filter(a => a.id === eq.id).length === 0) {
          this.equipments.push(eq);
        }
      });
      await this.getEquipmentModels(res.result.map(eqp => eqp.equipmentModelId));
    });
  }

  async getEquipmentModels(ids: number[]) {
    await this.equipmentModelService.list({ 'id[in]': `[${ids}]` }).then(res => {
      res.result.map(eq => {
        this.equipmentModelsById[eq.id] = eq;
      });
    });
  }

  setSpotCardsPaginated(appraisalContractCard, value) {
    appraisalContractCard.spotCardsPaginated = value;
  }

  setContractGlobal() {
    if (this.contractGlobalService.contracts != null) {
      this.contractGlobal = this.contractGlobalService.contracts;
      this.params['contractId[in]'] = `[${this.contractGlobalService.contracts}]`;
    } else {
      delete this.params['contractId[in]'];
    }
    this.contractGlobalService.contractEvent.subscribe(event => {
      this.contractGlobal = event;
      this.getAppraisals();
      if (event != null) {
        this.params['contractId[in]'] = `[${event}]`;
      } else {
        delete this.params['contractId[in]'];
      }
    });
  }

  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      search: [''],
      spotId: [],
      laneId: [],
      equipmentId: []
    });
    this.searchForm.get('spotId').valueChanges.subscribe(value => {
      if (value !== undefined) {
        this.params.spotId = value;
      } else {
        delete this.params.spotId;
      }
      this.getAppraisals();
    });
    this.searchForm.get('laneId').valueChanges.subscribe(value => {
      if (value !== undefined) {
        this.params.laneId = value;
      } else {
        delete this.params.laneId;
      }
      this.getAppraisals();
    });
    this.searchForm.get('equipmentId').valueChanges.subscribe(value => {
      if (value !== undefined) {
        this.params['equipment.id'] = value;
      } else {
        delete this.params['equipment.id'];
      }
      this.getAppraisals();
    });
  }

  handleSearch(event) {
    this.loading = true;
    if (event.target.value !== '') {
      this.searchValue = event.target.value.replace('CE', '').replace('ce', '');
      this.params['experimentCode[like]'] = `[%${this.searchValue}%]`;
      this.getAppraisals(true);
    } else {
      delete this.params['experimentCode[like]'];
      this.getAppraisals();
    }
  }

  handleLoading() {
    if (this.contractGlobalService.contracts != null) {
      if (this.loadingTimer === this.contractGlobal.length) {
        this.loading = false;
        this.loadingTimer = 0;
      }
    } else {
      if (this.loadingTimer === this.contracts.length) {
        setTimeout(() => {
          this.loading = false;
          this.loadingTimer = 0;
        }, 3500);
      }
    }
  }

  searchByExperimentCode(experimentCode) {
    this.loading = true;
    const data = this.appraisalContractCardsCopy.map(contract => ({ ...contract }));
    const result = data.map(contract => {
      contract.spotCards = contract.spotCards.map(spotCard => {
        const filteredAppraisals = spotCard.appraisals.filter(appraisal => appraisal.experimentCode.includes(experimentCode));
        return {
          ...spotCard,
          appraisals: filteredAppraisals
        };
      });
      return contract;
    }).filter(
      contract => contract.spotCards.some(spotCard => spotCard.appraisals.length > 0)
    );
    result.map(c => c.spotCards = c.spotCards.filter(sc => sc.appraisals.length > 0));
    this.loading = false;
    return result;
  }

  setViewMode(mode: 'contrato' | 'ensaio') {
    this.viewMode = mode;
  }

  buildFlatList() {
    const appraisals = [];
    this.appraisalContractCardsCopy.map(contractCard =>
      contractCard.spotCards.map(spotCard =>
        spotCard.appraisals.map(appraisal => appraisals.push(appraisal))
      )
    );
    appraisals.sort((appraisalA, appraisalB) => {
      const [seqA, yearA] = appraisalA.experimentCode.split('/').map(Number);
      const [seqB, yearB] = appraisalB.experimentCode.split('/').map(Number);

      if (yearA !== yearB) {
        return this.sortExperimentCodeOrder === 'desc' ? yearB - yearA : yearA - yearB;
      }
      return this.sortExperimentCodeOrder === 'desc' ? seqB - seqA : seqA - seqB;
    });
    this.appraisalsFlatList = appraisals;
  }

  toggleSortExperimentCode() {
    this.sortExperimentCodeOrder = this.sortExperimentCodeOrder === 'desc' ? 'asc' : 'desc';
    this.buildFlatList();
  }

  setFlatListPaginated(appraisals) {
    this.appraisalsFlatListPaginated = appraisals;
  }

  openOrCLoseAppraisalContractCard(appraisal) {
    appraisal.isOpen = !appraisal.isOpen;
  }

  openOrCloseAppraisalSpotCard(appraisal) {
    appraisal.isOpen = !appraisal.isOpen;
  }

  openCreateOrUpdateAppraisal(appraisal: any = {}) {
    let newAppraisal = true;
    if (Object.keys(appraisal).length !== 0) {
      newAppraisal = false;
    }
    appraisal.newAppraisal = newAppraisal;
    this.modalService.show(new ComponentModal(AppraisalCreateOrUpdateComponent, appraisal))
      .then(async data => {
        const modal = data as any;
        const savedEquipment = modal?.component?.instance?.appraisal;
        const i = this.appraisals.findIndex(e => e.id === savedEquipment?.id);
        if (i > -1) {
          this.appraisals[i] = savedEquipment;
        }
        if (newAppraisal) {
          let showMessage = true;
          const modalTitle = 'Certificado de Aferição';
          const modalMessage = 'Deseja gerar o pdf do certificado.';
          await this.modalService.show(new MessageModal(modalTitle, modalMessage, true))
            .then(() => {
              this.downloadAppraisalPDF(savedEquipment);
              return showMessage = false;
            })
            .catch(console.error)
            .finally(async () => {
              await this.ngOnInit();
            });
        } else {
          this.ngOnInit();
        }
      }).catch(err => {
        if (err instanceof ClosedModalError) {
          const modalError = err as ClosedModalError;
          this.modalState = (modalError.modal as ComponentModal).component.instance.lastState;
        } else {
          this.modalState = null;
        }
      });
  }

  openAppraisalMeasurements(appraisal = {}) {
    this.modalService.show(new ComponentModal(AppaisalMeasurementsUpdateComponent, appraisal))
      .then(data => {
        const modal = data as any;
        const savedEquipment = modal?.component?.instance?.appraisal;
        const i = this.appraisals.findIndex(e => e.id === savedEquipment?.id);
        if (i > -1) {
          this.appraisals[i] = savedEquipment;
        }
      }).catch(err => {
        if (err instanceof ClosedModalError) {
          const modalError = err as ClosedModalError;
          this.modalState = (modalError.modal as ComponentModal).component.instance.lastState;
        } else {
          this.modalState = null;
        }
      }).finally(() => {
        this.ngOnInit();
      });
  }

  async downloadAppraisalPDF(appraisal) {
    const isFieldsEmpty = await this.verifyFieldAppraisalEmpty(appraisal);
    if (!isFieldsEmpty) {
      this.appraisalService.equipmentAppraisalReport(appraisal.id).then(ait => {
        const fileTemplate = ait;
        const bodyTemplate = fileTemplate.body;
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(bodyTemplate);
        iframe.contentWindow.document.close();
        let bodyAit: HTMLElement = iframe.contentWindow.document.querySelector('.align-table');
        if (bodyAit == null) {
          bodyAit = iframe.contentWindow.document.querySelector('body');
        }
        html2canvas(bodyAit,
          {
            allowTaint: false,
            useCORS: true,
            logging: true
          }
        ).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
          const width = pdf.internal.pageSize.getWidth();
          const height = canvas.height * width / canvas.width;
          pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
          const codeAppraisal = appraisal.experimentCode || '';
          const now = new Date().toISOString();
          const startDate = moment(now).format('DD-MM-YYYY');
          const nameReport = `${appraisal.contractId}_CertificadoAfericao_${startDate}.pdf`;
          pdf.save(nameReport); // Generated PDF
          document.body.removeChild(iframe);
        });
      }).catch(error => {
        console.error('Failed AppraisalTemplate', error);
        this.alertService.show(new AlertItem('AppraisalTemplateError', AlertType.danger));
      });
    }
  }

  async downloadMeasurementsPDF(appraisal) {
    const isFieldsEmpty = await this.verifyFieldMeasurementsEmpty(appraisal);
    if (!isFieldsEmpty) {
      this.appraisalMeasurementsService.downloadMeasurementPdf(appraisal.id).then(ait => {
        const fileTemplate = ait;
        const bodyTemplate = fileTemplate.body;
        const iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(bodyTemplate);
        iframe.contentWindow.document.close();
        let bodyAit: HTMLElement = iframe.contentWindow.document.querySelector('.align-table');
        if (bodyAit == null) {
          bodyAit = iframe.contentWindow.document.querySelector('body');
        }
        html2canvas(bodyAit,
          {
            allowTaint: false,
            useCORS: true,
            logging: true
          }
        ).then(canvas => {
          const contentDataURL = canvas.toDataURL('image/png');
          const pdf = new jsPDF('p', 'mm', 'a4'); // A4 size page of PDF
          const width = pdf.internal.pageSize.getWidth();
          const height = canvas.height * width / canvas.width;
          pdf.addImage(contentDataURL, 'PNG', 0, 0, width, height);
          const codeAppraisal = appraisal.experimentCode || '';
          const now = new Date().toISOString();
          const startDate = moment(now).format('DD-MM-YYYY');
          const nameReport = `${appraisal.contractId}_Registro_de_Medicao_${startDate}.pdf`;
          pdf.save(nameReport); // Generated PDF
          document.body.removeChild(iframe);
        });
      }).catch(error => {
        console.error('Failed AppraisalTemplate', error);
        this.alertService.show(new AlertItem('AppraisalTemplateError', AlertType.danger));
      });
    }
  }

  async verifyFieldAppraisalEmpty(appraisal = null) {
    if (!appraisal) {
      return;
    }
    if (appraisal.equipment.additionalMainSeals === '') {
      delete appraisal.equipment.additionalMainSeals;
    }
    const fields = Object.keys(appraisal);
    let showMessage = false;
    for (const field of fields) {
      if (appraisal[field] != null && typeof appraisal[field] === 'object' && Object.keys(appraisal[field]).length > 0) {
        for (const key of Object.keys(appraisal[field])) {
          if (appraisal[field][key] == null || appraisal[field][key] === 0 || appraisal[field][key] === '') {
            showMessage = true;
            break;
          }
        }
      } else if (appraisal[field] == null || appraisal[field] === 0 || appraisal[field] === '') {
        showMessage = true;
      }
      if (showMessage) {
        break;
      }
    }
    if (showMessage) {
      const modalTitle = 'Certificado com campos em branco';
      const modalMessage = 'Dados que compõe o certificado não foram preechidos. Tem certeza que deseja gerar o certificado?';
      await this.modalService.show(new MessageModal(modalTitle, modalMessage, true))
        .then(() => showMessage = false)
        .catch(console.error);
    }
    return showMessage;
  }

  async verifyFieldMeasurementsEmpty(appraisal = null) {
    if (!appraisal) {
      return;
    }
    const fields = Object.keys(appraisal);
    let showMessage = false;
    await this.appraisalMeasurementsService.list({ order: 'code', appraisalId: appraisal.id }).then(resList => {
      this.appraisalMeasurements = resList.result;
      if (this.appraisalMeasurements.length === 10) {
        showMessage = false;
      } else {
        showMessage = true;
      }
    });
    if (showMessage) {
      const modalTitle = 'Registro de Medição com campos em branco';
      const modalMessage = `Dados que compõe o Registro de Medição não foram preechidos.
        Tem certeza que deseja gerar o Registro de Medição?`;
      await this.modalService.show(new MessageModal(modalTitle, modalMessage, true))
        .then(() => showMessage = false)
        .catch(console.error);
    }
    return showMessage;
  }

  async openDownloadModal(appraisal = null) {
    await this.modalService.show(new ComponentModal(ExportModalComponent, appraisal));
  }
}
